import { RowStatus, cn } from '@orgus/ui';
import type { RowStatusProps } from '@orgus/ui';
import { HEALTH_LABEL } from './model.ts';
import type { RepoHealth } from './model.ts';

/** A repo's one status: grey when healthy or not checked yet, colour only when a person should look. */
export function healthRowStatus(health: RepoHealth): Pick<RowStatusProps, 'tone' | 'icon' | 'label'> {
  const label = HEALTH_LABEL[health];
  switch (health) {
    case 'attention':
      return { tone: 'attention', icon: 'warning', label };
    case 'failing':
    case 'error':
      return { tone: 'danger', icon: 'failed', label };
    case 'pending':
      return { tone: 'neutral', icon: 'queued', label };
    default:
      return { tone: 'neutral', icon: 'done', label };
  }
}

/** A repo's discipline status: always icon plus label, never colour alone. */
export function HealthBadge({ health, hideLabel, className }: { health: RepoHealth; hideLabel?: RowStatusProps['hideLabel']; className?: string }) {
  return <RowStatus {...healthRowStatus(health)} hideLabel={hideLabel} className={className} />;
}

/** The score as a number; coloured only below 90, a dash before the first check or after a failed one. */
export function ScoreText({ health, score, className }: { health: RepoHealth; score: number | undefined; className?: string }) {
  const shown = health === 'pending' || health === 'error' || score === undefined;
  return (
    <span className={cn('font-medium num', shown ? 'text-fg-subtle' : health === 'attention' ? 'text-status-attention' : health === 'failing' ? 'text-status-danger' : 'text-fg', className)}>
      {shown ? '-' : score}
    </span>
  );
}
